var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhitestart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.1191 39.4874C44.7983 39.4874 39.5067 44.6321 39.5067 51.0994V75.3529C39.5067 76.0025 38.9802 76.5291 38.3308 76.5291C37.6813 76.5291 37.1548 76.0025 37.1548 75.3529V51.0994C37.1548 44.6321 31.8632 39.4874 25.3956 39.4874H1.2892C0.639758 39.4874 0.113281 38.9609 0.113281 38.3114C0.113281 37.662 0.639758 37.1355 1.2892 37.1355H25.3956C31.8632 36.9885 37.1548 31.8439 37.0078 25.3763V1.34341C37.0078 0.653379 37.5672 0.0939941 38.2573 0.0939941C38.9473 0.0939941 39.5067 0.653379 39.5067 1.34341V25.3763C39.5067 31.8439 44.7983 36.9885 51.1191 36.9885H75.2986C75.9886 36.9885 76.5484 37.5479 76.5484 38.238C76.5484 38.928 75.9886 39.4874 75.2986 39.4874H51.1191Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 77,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitestart);
export default __webpack_public_path__ + "static/media/whitestart.1b586367dec86b1beaa260c30ed0f10b.svg";
export { ForwardRef as ReactComponent };